import { render, staticRenderFns } from "./footer-standard.vue?vue&type=template&id=a99ee974&"
import script from "./footer-standard.vue?vue&type=script&lang=js&"
export * from "./footer-standard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports